// PrintTerimaanLaporan.js
// Generates HTML for Terimaan Laporan print preview

export function generatePrintTerimaanLaporanHtml({ data, tarikhMula, tarikhTamat, bahagian }) {
  // Header HTML (matches sample)
  const headerHtml = `
    <div class="header">
      <img id="logoKejora" src="/build/kejora.png" alt="KEJORA" style="height:48px;vertical-align:middle;display:block;margin:0 auto 8px auto;" />
      <div class="title">LEMBAGA KEMAJUAN JOHOR TENGGARA</div>
  <div class="title">LAPORAN TERIMAAN DARI ${tarikhMula} SEHINGGA ${tarikhTamat}</div>
  ${bahagian ? `<div class="title">BAHAGIAN: ${bahagian === 'SEMUA' ? 'SEMUA (KECUALI ADMIN)' : bahagian}</div>` : ''}
    </div>
  `;
  // Table header
  const tableHeader = `
    <tr>
      <th style="width: 30px;">BIL</th>
      <th style="width: 80px; text-align:center;">TARIKH RESIT</th>
      <th style="width: 80px; text-align:center;">JENIS BAYARAN</th>
      <th style="width: 200px;">NAMA</th>
      <th style="width: 200px;">ALAMAT HARTA</th>
      <th style="width: 100px;">NO INBOIS</th>
      <th style="width: 80px; text-align:right;">JUMLAH</th>
    </tr>
  `;
  // Helper to format date as DD/MM/YYYY
  function formatDate(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }
  // Helper to build full address from harta fields
  const buildAddress = (row) => {
    const parts = [
      row.alamat1_harta,
      row.alamat2_harta,
      row.poskod_harta,
      row.bandar_harta,
      row.negeri_harta
    ].filter(p => p && String(p).trim());
    return parts.join(', ');
  };

  // Table rows
  const rowsHtml = (data || []).map((row, idx) => `
    <tr>
      <td class="number">${idx + 1}</td>
      <td class="number">${formatDate(row.tarikh_resit)}</td>
      <td class="number">${row.cara_bayaran || ""}</td>
      <td>${row.nama || ""}</td>
      <td>${buildAddress(row) || ""}</td>
      <td class="number">${row.no_inbois || ""}</td>
  <td class="amount">${row.jumlah ? formatNumberWithCommas(parseFloat(row.jumlah)) : ""}</td>
    </tr>
  `).join("");
  // Calculate total jumlah
  const totalJumlah = (data || []).reduce((sum, row) => sum + (parseFloat(row.jumlah) || 0), 0);
  // Format number with commas
  function formatNumberWithCommas(num) {
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // Table HTML with JUMLAH row
  const tableHtml = `
    <table>
      <thead>${tableHeader}</thead>
      <tbody>${rowsHtml}
        <tr>
          <td colspan="6" class="amount" style="font-weight:bold; text-align:right;">JUMLAH</td>
          <td class="amount" style="font-weight:bold;">${formatNumberWithCommas(totalJumlah)}</td>
        </tr>
      </tbody>
    </table>
  `;
  // Full HTML with requested style and wait for image load before print
  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>Laporan Terimaan</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; font-size: 12px; }
          .header { text-align: center; margin-bottom: 20px; }
          .title { font-weight: bold; font-size: 14px; margin-bottom: 10px; }
          table { width: 100%; border-collapse: collapse; border: 1px solid black; }
          th, td { border: 1px solid black; padding: 4px; text-align: left; font-size: 10px; }
          th { background-color: #f0f0f0; font-weight: bold; text-align: center; }
          .number { text-align: center; }
          .amount { text-align: right; }
          .footer { margin-top: 20px; display: flex; justify-content: space-between; font-size: 10px; }
          @media print { body { margin: 10px; } .no-print { display: none; } }
        </style>
        <script>
          window.onload = function() {
            var img = document.getElementById('logoKejora');
            if (img && !img.complete) {
              img.onload = function() { window.print(); };
            } else {
              window.print();
            }
          };
        </script>
      </head>
      <body>
        ${headerHtml}
        ${tableHtml}
      </body>
    </html>
  `;
}
